const SPS = module.exports = {}

SPS.parse = function(sps_hex) {
  function readBits(num) {
    return parseInt(bits.splice(0, num).join(''), 2)
  }

  function readExpGolomb() {
    let cnt = 0
    while(!bits[cnt]) cnt++
    const value_bits = bits.slice(cnt, cnt*2+1)
    bits = bits.slice(cnt*2+1)
    return parseInt(value_bits.join(''), 2)-1
  }

  function skipScalingList(count) {
    const seq_scaling_list_present_flags = readBits(1)
    if(!seq_scaling_list_present_flags) return
    let lastScale = 8; let nextScale = 8; let deltaScale
    for(let j=0; j<count; j++) {
      if(nextScale) {
        deltaScale = readExpGolomb()
        nextScale = (lastScale + deltaScale + 256) % 256
      }
      lastScale = nextScale || lastScale
    }
  }

  let bits =
    sps_hex instanceof Uint8Array ? Array.from(sps_hex).map(x=>parseInt(x).toString(2).padStart(8, '0')).join('').split('').map(x=>parseInt(x)) :
      sps_hex.match(/(..)/g).map(x=>parseInt(x, 16).toString(2).padStart(8, '0')).join('').split('').map(x=>parseInt(x))

  const sps = {
    frameCropLeftOffset: 0,
    frameCropRightOffset: 0,
    frameCropTopOffset: 0,
    frameCropBottomOffset: 0,
    sarScale: 1,
  }

  sps.header = readBits(8)
  sps.profileIdc = readBits(8)
  sps.profileCompat = readBits(5)
  readBits(3)
  sps.levelIdc = readBits(8)
  sps.seq_parameter_set_id = readExpGolomb()
  if([44, 83, 86, 100, 110, 118, 122, 128, 244].indexOf(sps.profileIdc)>=0) {
    // some profiles have more optional data we don't need
    sps.chromaFormatIdc = readExpGolomb()
    if(sps.chromaFormatIdc === 3) readBits(1) // separate_colour_plane_flag
    sps.bit_depth_luma_minus8 = readExpGolomb()
    sps.bit_depth_chroma_minus8 = readExpGolomb()
    sps.qpprime_y_zero_transform_bypass_flag = readBits(1)
    sps.seq_scaling_matrix_present_flag = readBits(1)
    if(sps.seq_scaling_matrix_present_flag) {
      sps.scalingListCount = sps.chromaFormatIdc===3 ? 12 : 8
      for(let i=0; i<sps.scalingListCount; i++) {
        skipScalingList(i<6 ? 16 : 64)
      }
    }
  }
  sps.log2_max_frame_num_minus4 = readExpGolomb()
  sps.picOrderCntType = readExpGolomb()
  if(sps.picOrderCntType===0) {
    sps.log2_max_pic_order_cnt_lsb_minus4 = readExpGolomb()
  }else if(sps.picOrderCntType===1) {
    sps.delta_pic_order_always_zero_flag = readBits(1)
    sps.offset_for_non_ref_pic = readExpGolomb()
    sps.offset_for_top_to_bottom_field = readExpGolomb()
    sps.numRefFramesInPicOrderCntCycle = readExpGolomb()
    for(let i = 0; i<sps.numRefFramesInPicOrderCntCycle; i++) readExpGolomb() // offset_for_ref_frame[i]
  }
  sps.max_num_ref_frames = readExpGolomb()
  sps.gaps_in_frame_num_value_allowed_flag = readBits(1)
  sps.picWidthInMbsMinus1 = readExpGolomb()
  sps.picHeightInMapUnitsMinus1 = readExpGolomb()
  sps.frameMbsOnlyFlag = readBits(1)
  if(!sps.frameMbsOnlyFlag) sps.mb_adaptive_frame_field_flag = readBits(1)
  sps.direct_8x8_inference_flag = readBits(1)
  sps.frame_cropping_flag = readBits(1)
  if(sps.frame_cropping_flag) {
    sps.frameCropLeftOffset = readExpGolomb()
    sps.frameCropRightOffset = readExpGolomb()
    sps.frameCropTopOffset = readExpGolomb()
    sps.frameCropBottomOffset = readExpGolomb()
  }
  sps.vui_parameters_present_flag = readBits(1)
  if(sps.vui_parameters_present_flag) {
    sps.aspect_ratio_info_present_flag = readBits(1)
    if(sps.aspect_ratio_info_present_flag) {
      sps.aspectRatioIdc = readBits(8)
      const RATIOS = [null, [1, 1], [12, 11], [10, 11], [16, 11], [40, 33], [24, 11], [20, 11], [32, 11], [80, 33], [18, 11], [15, 11], [64, 33], [160, 99], [4, 3], [3, 2], [2, 1]]
      sps.sarRatio = RATIOS[sps.aspectRatioIdc]
      if(sps.aspectRatioIdc===255) sps.sarRatio = [readBits(16), readBits(16)]
      if(sps.sarRatio) sps.sarScale = sps.sarRatio[0] / sps.sarRatio[1]
    }
  }
  sps.width = Math.ceil((((sps.picWidthInMbsMinus1 + 1) * 16) - sps.frameCropLeftOffset * 2 - sps.frameCropRightOffset * 2) * sps.sarScale)
  sps.height = ((2 - sps.frameMbsOnlyFlag) * (sps.picHeightInMapUnitsMinus1 + 1) * 16) - ((sps.frameMbsOnlyFlag? 2 : 4) * (sps.frameCropTopOffset + sps.frameCropBottomOffset))
  return sps
} // parseSPS
